import Navigation from "@/components/Navigation";
import ChatbotWidget from "@/components/ChatbotWidget";

const LOGO = "/assets/logo.png";

export default function PrivacyPolicyPage() {
  return (
    <>
      <div className="star-bg-fixed" aria-hidden="true" />
      <div className="star-tint min-h-screen relative">
        <Navigation />

        <section
          id="privacy"
          className="pt-40 pb-16 sm:pt-48 sm:pb-20 border-b border-white/5"
          data-testid="privacy-section"
        >
          <div className="max-w-3xl mx-auto px-6 sm:px-12 text-center">
            <img src={LOGO} alt="AirStageX" className="h-16 sm:h-20 mx-auto mb-10 opacity-95" />
            <p className="overline text-[#007AFF] mb-6 drift">Legal</p>
            <h1 className="font-heading font-light text-white text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.08] mb-7">
              Privacy Policy
            </h1>
            <p className="text-zinc-400 text-sm">Last updated: February 2026</p>
          </div>
        </section>

        <section className="py-16 sm:py-24" data-testid="privacy-content">
          <div className="max-w-3xl mx-auto px-6 sm:px-12 text-zinc-200 text-base leading-relaxed space-y-10 text-left">
            <p>
              AirStageX (&ldquo;we&rdquo;, &ldquo;us&rdquo;, &ldquo;our&rdquo;) is committed to protecting and
              respecting your privacy. This Privacy Policy explains how we collect, use, store and protect the
              personal information you provide when you interact with our website and services.
            </p>

            <div>
              <h2 className="font-heading text-2xl font-light text-white mb-4">1. Information We Collect</h2>
              <p>
                We may collect the following information when you submit a waitlist, partnership or contact
                enquiry: your name, email address, location, spending preferences, company details and any
                message you choose to send us. When you sign in to restricted areas, we may receive your name,
                email and profile information from your authentication provider.
              </p>
            </div>

            <div>
              <h2 className="font-heading text-2xl font-light text-white mb-4">2. How We Use Your Information</h2>
              <p>
                We use your information to: respond to your enquiries; manage waitlist and partnership requests;
                personalise your experience; communicate with you about our services; and comply with our legal
                obligations. We do not sell your personal information to third parties.
              </p>
            </div>

            <div>
              <h2 className="font-heading text-2xl font-light text-white mb-4">3. Legal Basis for Processing</h2>
              <p>
                We process your data on the basis of your consent, our legitimate interests in operating and
                promoting AirStageX, and where necessary to comply with applicable laws, including the UK GDPR.
              </p>
            </div>

            <div>
              <h2 className="font-heading text-2xl font-light text-white mb-4">4. Data Storage &amp; Security</h2>
              <p>
                Your information is stored securely and access is restricted to authorised personnel. We retain
                personal data only for as long as necessary to fulfil the purposes set out in this policy or as
                required by law.
              </p>
            </div>

            <div>
              <h2 className="font-heading text-2xl font-light text-white mb-4">5. Sharing Your Information</h2>
              <p>
                We may share your information with trusted service providers who help us operate our website and
                services, and where required by law. All such parties are obliged to keep your information secure
                and to use it only for the purposes we specify.
              </p>
            </div>

            <div>
              <h2 className="font-heading text-2xl font-light text-white mb-4">6. Your Rights</h2>
              <p>
                You have the right to access, correct, update or request deletion of your personal data, to
                object to or restrict its processing, and to withdraw consent at any time. To request deletion of
                your data, please visit our{" "}
                <a href="/delete-account" className="text-[#007AFF] hover:underline" data-testid="privacy-delete-link">
                  Delete Account
                </a>{" "}
                page.
              </p>
            </div>

            <div>
              <h2 className="font-heading text-2xl font-light text-white mb-4">7. Cookies</h2>
              <p>
                Our website may use cookies and similar technologies to operate effectively and to improve your
                experience. You can control cookies through your browser settings.
              </p>
            </div>

            <div>
              <h2 className="font-heading text-2xl font-light text-white mb-4">8. Changes to This Policy</h2>
              <p>
                We may update this Privacy Policy from time to time. Any changes will be posted on this page with
                an updated revision date.
              </p>
            </div>

            <div>
              <h2 className="font-heading text-2xl font-light text-white mb-4">9. Contact Us</h2>
              <p>
                If you have any questions about this Privacy Policy or how we handle your data, please contact us
                at{" "}
                <a href="mailto:enquiries@airstagex.com" className="text-[#007AFF] hover:underline" data-testid="privacy-contact-email">
                  enquiries@airstagex.com
                </a>.
              </p>
            </div>
          </div>
        </section>

        <footer className="py-12 border-t border-white/5" data-testid="privacy-footer">
          <div className="max-w-7xl mx-auto px-6 sm:px-12 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-zinc-400 text-xs">All rights reserved &copy; 2025 AirStageX</p>
            <a href="/" className="text-zinc-300 text-xs hover:text-white transition-colors" data-testid="privacy-back-home">
              Back to home
            </a>
          </div>
        </footer>

        <ChatbotWidget />
      </div>
    </>
  );
}
